import React from "react";
import TopBar from "../components/TopBar";
import Footerr from "../components/Footerr/Footerr";
import NotFound from "../components/NotFound/NotFound";
import ProgressBar from "../components/ProgressBar";

function NotFoundPage() {
  return (
    <div>
      <ProgressBar />
      <TopBar />
      <NotFound />
      <Footerr />
    </div>
  );
}

export default NotFoundPage;
